import type { Education, MonthYear, Year } from '@seek/ca-myprofile-utils';

import type * as Schema from 'src/types/graphql';

import type { FormValues } from './types';

type FormValuesWithTracking = FormValues & {
  tracking?: Schema.TrackingInfo;
};

const normaliseInstituteText = (instituteText: string) =>
  instituteText.replace(/ \([A-Za-z].*\)$/, '');

export const getCompletionDate = (
  completed: boolean,
  completionDate?: MonthYear | Year | number,
) => {
  const normalisedCompletionDate = completionDate || null;
  return completed === true
    ? {
        completionYear:
          typeof normalisedCompletionDate === 'object' &&
          typeof normalisedCompletionDate?.year === 'number'
            ? normalisedCompletionDate.year
            : (normalisedCompletionDate as Schema.InputMaybe<
                Schema.Scalars['Int']['input']
              >),
        expectedCompletionDate: null,
      }
    : {
        completionYear: null,
        expectedCompletionDate:
          normalisedCompletionDate as Schema.Maybe<Schema.MonthYearInput>,
      };
};

export const qualificationFormUpdateToUpdateQualificationInput = ({
  id,
  completionDate,
  completed,
  institute,
  name,
  highlights,
  level2,
  ...restProps
}: FormValues): Schema.UpdateQualificationInput => ({
  id,
  name: {
    text: name.text,
    ontologyId: name?.ontologyId || null,
  },
  institute: {
    text: normaliseInstituteText(institute.text),
    ontologyId: institute?.ontologyId || null,
  },
  highlights: highlights || null,
  completed,
  ...getCompletionDate(completed, completionDate),
  level2: level2 || null,
  ...restProps,
});

export const qualificationFormOrEducationUpdateToConfirmQualificationInput = ({
  id,
  completionDate,
  completed,
  institute,
  name,
  highlights,
  level2,
  tracking,
}: FormValuesWithTracking | Education): Schema.ConfirmQualificationInput => ({
  id,
  name: {
    text: name.text,
    ontologyId: name?.ontologyId || null,
  },
  institute: {
    text: normaliseInstituteText(institute.text),
    ontologyId: institute?.ontologyId || null,
  },
  highlights: highlights || null,
  completed,
  ...getCompletionDate(completed, completionDate),
  tracking: tracking || null,
  level2: level2 || null,
});
